export class ProcessedTransactionByLastFourRequest
{
    lastFour: string;
    endDate: string;
    startDate: string;
}



